const CONTACT_FORM_EMAIL_BLACKLIST_DOMAINS = [
  '0-mail.com',
  '126.com',
  '163.com',
  '189.cn',
  '20mail.in',
  '21cn.com',
  'aim.com',
  'airmail.cc',
  'alice.it',
  'aliceadsl.fr',
  'altavista.com',
  'ameritech.net',
  'anonymous.to',
  'aol.com',
  'arcor.de',
  'att.net',
  'azet.sk',
  'bellsouth.net',
  'bigpond.com',
  'bigpond.net.au',
  'bk.ru',
  'bluewin.ch',
  'blueyonder.co.uk',
  'bol.com.br',
  'btinternet.com',
  'centrum.cz',
  'centurytel.net',
  'charter.net',
  'chello.nl',
  'club-internet.fr',
  'comcast.net',
  'countermail.com',
  'cox.net',
  'daum.net',
  'earthlink.net',
  'email.com',
  'enet.ie',
  'epost.de',
  'excite.com',
  'facebook.com',
  'fastmail.com',
  'fastmail.fm',
  'free.fr',
  'freenet.de',
  'frontiernet.net',
  'gawab.com',
  'gmail.com',
  'gmx.at',
  'gmx.biz',
  'gmx.ch',
  'gmx.com',
  'gmx.de',
  'gmx.info',
  'gmx.net',
  'gmx.org',
  'googlemail.com',
  'hanmail.net',
  'hetnet.nl',
  'hey.com',
  'hmail.com',
  'home.nl',
  'hotmail.be',
  'hotmail.ca',
  'hotmail.co.uk',
  'hotmail.com',
  'hotmail.de',
  'hotmail.es',
  'hotmail.fr',
  'hotmail.it',
  'hotmail.nl',
  'hush.ai',
  'hush.com',
  'hushmail.com',
  'icloud.com',
  'ig.com.br',
  'iinet.net.au',
  'inbox.com',
  'inbox.lv',
  'interia.pl',
  'juno.com',
  'kakao.com',
  'kpnmail.nl',
  'laposte.net',
  'lavabit.com',
  'libero.it',
  'live.be',
  'live.ca',
  'live.co.uk',
  'live.com',
  'live.com.au',
  'live.de',
  'live.fr',
  'live.it',
  'live.nl',
  'lycos.com',
  'mac.com',
  'mail.bg',
  'mail.com',
  'mail.de',
  'mail.ee',
  'mail.gmx',
  'mail.ru',
  'mailbox.org',
  'mailfence.com',
  'me.com',
  'mein.gmx',
  'msn.com',
  'myway.com',
  'naver.com',
  'neo.space',
  'netcourrier.com',
  'netzero.net',
  'neuf.fr',
  'ntlworld.com',
  'o2.pl',
  'office365.com',
  'online.de',
  'op.pl',
  'optonline.net',
  'optusnet.com.au',
  'orange.fr',
  'outlook.at',
  'outlook.be',
  'outlook.co.uk',
  'outlook.com',
  'outlook.de',
  'outlook.es',
  'outlook.fr',
  'outlook.it',
  'outlook.nl',
  'ozemail.com.au',
  'planet.nl',
  'pm.me',
  'post.cz',
  'posteo.de',
  'privateemail.com',
  'proton.me',
  'protonmail.ch',
  'protonmail.com',
  'qq.com',
  'rambler.ru',
  'rediffmail.com',
  'rocketmail.com',
  'runbox.com',
  'safe-mail.net',
  'sapo.pt',
  'sbcglobal.net',
  'seznam.cz',
  'sfr.fr',
  'shaw.ca',
  'sigaint.org',
  'sky.com',
  'skynet.be',
  'smail.com',
  'soverin.net',
  'startmail.com',
  'sympatico.ca',
  't-online.de',
  'telia.com',
  'telenet.be',
  'terra.com.br',
  'thexyz.com',
  'tin.it',
  'tiscali.co.uk',
  'tiscali.it',
  'titan.email',
  'tutanota.com',
  'uol.com.br',
  'ukr.net',
  'verizon.net',
  'virgilio.it',
  'virginmedia.com',
  'voila.fr',
  'wanadoo.fr',
  'web.de',
  'windowslive.com',
  'windstream.net',
  'wp.pl',
  'xmail.com',
  'xtra.co.nz',
  'yahoo.at',
  'yahoo.ca',
  'yahoo.ch',
  'yahoo.co.id',
  'yahoo.co.in',
  'yahoo.co.jp',
  'yahoo.co.nz',
  'yahoo.co.uk',
  'yahoo.com',
  'yahoo.com.ar',
  'yahoo.com.au',
  'yahoo.com.br',
  'yahoo.com.mx',
  'yahoo.com.sg',
  'yahoo.de',
  'yahoo.es',
  'yahoo.fr',
  'yahoo.in',
  'yahoo.it',
  'yandex.by',
  'yandex.com',
  'yandex.kz',
  'yandex.ru',
  'ymail.com',
  'zoho.com',
  'zohomail.com',
  'zonnet.nl',
] as const;

export const CONTACT_FORM_EMAIL_BLACKLIST = new Set(
  CONTACT_FORM_EMAIL_BLACKLIST_DOMAINS.map(domain => domain.toLowerCase())
);

export const getEmailDomain = (email: string): string => {
  const atIndex = email.lastIndexOf('@');
  if (atIndex === -1) {
    return '';
  }

  return email.slice(atIndex + 1).trim().toLowerCase();
};

export const isBlacklistedContactEmailDomain = (email: string): boolean => {
  const domain = getEmailDomain(email);
  if (!domain) {
    return false;
  }

  return CONTACT_FORM_EMAIL_BLACKLIST.has(domain);
};
